
import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import { PageMeta } from '@/components/seo/PageMeta';
import { OrganizationJsonLd, WebsiteJsonLd, HowToJsonLd, HOMEPAGE_FAQ_ITEMS } from '@/components/seo';
import Hero from '@/components/home/Hero';
import CategoryCarousel from '@/components/home/CategoryCarousel';
import PopularActivitiesSection from '@/components/home/PopularActivitiesSection';
import GroupVoteShowcase from '@/components/home/GroupVoteShowcase';
import HowItWorksSection from '@/components/home/HowItWorksSection';
import ProBannerSection from '@/components/home/ProBannerSection';

function HomepageFaqItem({ question, answer }: { question: string; answer: string }) {
  const [open, setOpen] = React.useState(false);
  const id = React.useId();
  return (
    <div className="py-4">
      <dt>
        <button
          type="button"
          aria-expanded={open}
          aria-controls={id}
          onClick={() => setOpen((v) => !v)}
          className="flex w-full items-center justify-between text-left text-base font-semibold text-brand-text hover:text-brand-primary transition-colors gap-4"
        >
          <span>{question}</span>
          <ChevronDown
            size={18}
            className={`flex-shrink-0 text-brand-primary transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
          />
        </button>
      </dt>
      <dd id={id} hidden={!open} className="mt-2 text-brand-text-muted text-sm leading-relaxed">
        {answer}
      </dd>
    </div>
  );
}

const Index = () => (
  <div className="min-h-screen flex flex-col bg-brand-bg">
    <PageMeta
      title="FullBook – Réservez vos activités indoor en Île-de-France"
      description="Réservez en ligne vos activités indoor en Île-de-France : bowling, karting, escape game, laser game, padel et plus encore. Paiement sécurisé et confirmation instantanée."
      canonical="/"
    />
    <OrganizationJsonLd />
    <WebsiteJsonLd />
    <HowToJsonLd />

    <Navbar />

    <main className="flex-1">
      <Hero />
      <CategoryCarousel />
      <PopularActivitiesSection />
      <GroupVoteShowcase />
      <HowItWorksSection />
      <ProBannerSection />

      {/* FAQ */}
      <section className="max-w-[1280px] mx-auto px-4 sm:px-6 py-10 sm:py-20" aria-labelledby="faq-heading">
        <div className="max-w-3xl mx-auto">
          <h2
            id="faq-heading"
            className="font-heading font-extrabold text-brand-dark text-center mb-8 tracking-tight"
            style={{ fontSize: 'clamp(28px, 3vw, 40px)', letterSpacing: '-0.02em' }}
          >
            Questions fréquentes
          </h2>
          <dl className="divide-y divide-brand-divider">
            {HOMEPAGE_FAQ_ITEMS.map(({ q, a }) => (
              <HomepageFaqItem key={q} question={q} answer={a} />
            ))}
          </dl>
          <div className="text-center mt-8">
            <Link to="/faq" className="text-brand-primary font-semibold hover:underline text-sm">
              Voir toutes les questions fréquentes →
            </Link>
          </div>
        </div>
      </section>
    </main>

    <Footer />
  </div>
);

export default Index;
